import { render, staticRenderFns } from "./NotFoundError.vue?vue&type=template&id=674094cc&scoped=true&"
import script from "./NotFoundError.vue?vue&type=script&lang=ts&"
export * from "./NotFoundError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674094cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('674094cc', component.options)
    } else {
      api.reload('674094cc', component.options)
    }
    module.hot.accept("./NotFoundError.vue?vue&type=template&id=674094cc&scoped=true&", function () {
      api.rerender('674094cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/lessons/lesson/svgs/NotFoundError.vue"
export default component.exports